// Module
var code = `<mat-dialog-content>
    <div class="hoa-dialog__container">
        <div class="hoa-dialog__header">
            <h1 tid="confirmAddressTitle">Confirm Address</h1>
        </div>
        <div class="hoa-dialog__main">
            <p tid="confirmAddressBody1">These are the Property IDs associated with the address entered.</p>
            <p tid="confirmAddressBody2">
                Management ID: {{data.resp.pmcCouponId}}<br>
                Association ID: {{data.resp.hoaCouponId}}<br>
                Property ID: {{data.resp.propertyCouponId}}
            </p>
            <p tid="confirmAddressBody3">
                Please select OK, to accept the Property IDs or cancel to re-enter the address.
            </p>
            <p tid="confirmAddressBody4">
                For questions regarding the address found, please contact your management company.
            </p>
        </div>
        <div class="hoa-dialog__footer" ifOverFlowXClass="hoa-dialog__footer--overflowX">
            <button class="Button Button--link Button--minWidth130"
                    (click)="closeThisDialog('O')"
                    tid="confirmAddressCancelButton">
                Cancel
            </button>
            <button class="Button Button--blue Button--minWidth130"
                    (click)="closeThisDialog('A')"
                    tid="confirmAddressOkButton">
                OK
            </button>
        </div>
    </div>
</mat-dialog-content>`;
// Exports
module.exports = code;